import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'ESTOQUE_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'ESTOQUE_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('estoqueForm', registro)
    ];
}

export function getLista() {
    const request = axios.get(`${consts.API_URL}/estoque`);
    return {
        type: 'ESTOQUE_LISTADO',
        payload: request
    };
}

export function getListaDescargaBase() {
    const request = axios.get(`${consts.API_URL}/estoque?base=true`);
    return {
        type: 'ESTOQUE_BASE_LISTADO',
        payload: request
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/estoque`, {
                ...registro,
                datahora_estoque: DateFormat.formatarDataHoraTelaParaSql(registro.datahora_estoque),
                quantidade: FormatUtils.formatarValorBanco(registro.quantidade, 2),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/estoque`, {
                ...registro,
                datahora_estoque: DateFormat.formatarDataHoraTelaParaSql(registro.datahora_estoque),
                quantidade: FormatUtils.formatarValorBanco(registro.quantidade, 2),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function carregar(registro) {
    return (dispatch, getState) => {

        axios.put(`${consts.API_URL}/estoque/carregar`, {
            ...registro,
            id_usuario_alteracao: getState().auth.usuario.id
        }).then(resp => {
            setSuccess('Operação Realizada com sucesso.');
            dispatch(getLista());
            dispatch(setModoTela('lista'));
        }).catch(e => {
            setErroAPI(e);
        });
    };
}

export function descarregar(registro) {
    return (dispatch, getState) => {

        axios.put(`${consts.API_URL}/estoque/descarregar`, {
            ...registro,
            id_usuario_alteracao: getState().auth.usuario.id
        }).then(resp => {
            setSuccess('Operação Realizada com sucesso.');
            dispatch(getLista());
            dispatch(setModoTela('lista'));
        }).catch(e => {
            setErroAPI(e);
        });
    };
}

export function chegada(registro) {
    return (dispatch, getState) => {

        axios.put(`${consts.API_URL}/estoque/chegada`, {
            ...registro,
            id_usuario_alteracao: getState().auth.usuario.id
        }).then(resp => {
            setSuccess('Operação Realizada com sucesso.');
            dispatch(getLista());
            dispatch(setModoTela('lista'));
        }).catch(e => {
            setErroAPI(e);
        });
    };
}

export function desfazer(registro) {
    return (dispatch, getState) => {

        axios.put(`${consts.API_URL}/estoque/desfazer`, {
            ...registro,
            id_usuario_alteracao: getState().auth.usuario.id
        }).then(resp => {
            setSuccess('Operação Realizada com sucesso.');
            dispatch(getLista());
            dispatch(setModoTela('lista'));
        }).catch(e => {
            setErroAPI(e);
        });
    };
}

export function alterarDescargaBase(registro) {
    return (dispatch, getState) => {
        dispatch(setAguardando(true));
		axios.put(`${consts.API_URL}/estoque/alterarBase`, {
			...registro
		}).then(resp => {                
            setSuccess('Operação Realizada com sucesso.');
            dispatch(getListaDescargaBase());
            dispatch(setAguardando(false));
        }).catch(e => {
            setErroAPI(e);
            dispatch(setAguardando(false));
        });
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/estoque?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaPedido() {
    const request = axios.get(`${consts.API_URL}/pedido/logisticadireta`);
    return {
        type: 'ESTOQUE_PEDIDO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaProduto() {
    const request = axios.get(`${consts.API_URL}/produto/listarSelect`);
    return {
        type: 'ESTOQUE_PRODUTO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaUnidade() {
    const request = axios.get(`${consts.API_URL}/unidade/listarSelect`);
    return {
        type: 'ESTOQUE_UNIDADE_SELECT_LISTADO',
        payload: request
    };
}

export function getListaTanque() {
    const request = axios.get(`${consts.API_URL}/tanque/listarSelect`);
    return {
        type: 'ESTOQUE_TANQUE_SELECT_LISTADO',
        payload: request
    };
}

export function getListaMotorista() {
    const request = axios.get(`${consts.API_URL}/motorista/listarSelect`);
    return {
        type: 'ESTOQUE_MOTORISTA_SELECT_LISTADO',
        payload: request
    };
}

export function getListaVeiculo() {
    const request = axios.get(`${consts.API_URL}/veiculo/listarSelect`);
    return {
        type: 'ESTOQUE_VEICULO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaDistribuidora() {
    const request = axios.get(`${consts.API_URL}/distribuidora/listarSelect`);
    return {
        type: 'ESTOQUE_DISTRIBUIDORA_SELECT_LISTADO',
        payload: request
    };
}
	